import React from 'react'
import ToggleButton from 'react-toggle-button'
import { FormInputContainer, FormInputLabel } from '@appearance/styled'
import i18n from '@localization/i18n'

export default ({ value, label, onToggle, width }) => {
    return (
        <FormInputContainer width={width}>
            {label && (
                <FormInputLabel lang={i18n.locale}>
                    {label} -{' '}
                    {value ? i18n.t('edit_user.yes') : i18n.t('edit_user.no')}
                </FormInputLabel>
            )}
            <ToggleButton
                inactiveLabel={''}
                activeLabel={''}
                value={value}
                onToggle={onToggle}
            />
        </FormInputContainer>
    )
}
